var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ui bottom tab segment", attrs: { "data-tab": "basic" } },
    [
      _c(
        "form",
        {
          staticClass: "ui form",
          class: { loading: _vm.form.waiting, warning: _vm.form.hasErrors() },
        },
        [
          _c("div", { staticClass: "field" }, [
            _c(
              "button",
              {
                staticClass: "ui positive button",
                class: { loading: _vm.form.waiting },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.save()
                  },
                },
              },
              [_vm._v("保存する")]
            ),
          ]),
          _vm._v(" "),
          _c("basic-shop", { attrs: { form: _vm.form } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }